<template>
    <sub-frame title="受让方信息">
        <div slot="head">
            <mt-button icon="more" v-if="actions.length" type="primary" @click="sheetVisible=!sheetVisible"></mt-button>
        </div>
        <mt-actionsheet :actions="actions" v-model="sheetVisible"/>
        <template v-if="!editable">
            <mt-cell title="主体类型" :value="applicant.kind" />
            <mt-cell title="姓名" :value="applicant.name"/>
            <mt-cell title="性别" :value="applicant.sex"/>
            <mt-cell title="生日" :value="applicant.birthday"/>
            <mt-cell title="证件类型" :value="applicant.idType"/>
            <mt-cell title="证件号码" :value="applicant.idNum"/>
            <swipe-image :attachments="applicant.attachments"/>
        </template>
        <template v-else>
            <mt-cell title="主体类型" :value="applicant.kind" />
            <mt-cell title="姓名" :value="applicant.name">
                <input type="text" v-model="applicantModified.name"/>
            </mt-cell>
            <mt-cell title="性别" :value="applicant.sex"/>
            <mt-cell title="生日" :value="applicant.birthday"/>
            <mt-cell title="证件类型" :value="applicant.idType">
                <input type="text" v-model="applicantModified.idType"/>
            </mt-cell>
            <mt-cell title="证件号码" :value="applicant.idNum">
                <input type="text" v-model="applicantModified.idNum"/>
            </mt-cell>
            <swipe-image :attachments="applicant.attachments"/>
        </template>
    </sub-frame>
</template>

<script>
    export default {
        name: "PersonBuyer",
        data() {
            return {
                applyGuid: this.$route.query.applyGuid,
                applicant: {
                    guid: this.$route.query.applicantGuid,
                    role: '',
                    kind: '',
                    name: '',
                    sex: '',
                    birthday: '',
                    idType: '',
                    idNum: '',
                    attachments: [],
                },
                applicantModified: null,
                sheetVisible: false,
                editable: false,
                actionsAll: [
                    {
                        name: '编辑修改',
                        method: () => this.editable = true
                    },
                    {
                        name: '保存修改',
                        method: this.saveApplicantInfo,
                    }
                ],
            }
        },
        computed: {
            actions() {
                if (this.$store.state.notaryRights.applicant_modify) {
                    return [this.actionsAll[this.editable ? 1 : 0]];
                } else {
                    return [];
                }
            }
        },
        created() {
            this.getApplicantInfo();
        },
        methods: {
            async getApplicantInfo() {
                let res = await this.$axios.get(`/applycheck/applyapplicant`,{
                    params: {
                        applicantGuid: this.applicant.guid,
                        applicantType: 'personbuyer'
                    }
                });
                this.applicant = res.data;
                this.applicantModified = Object.assign({}, res.data);
            },
            async saveApplicantInfo() {
                await this.$axios.post(`/applycheck/applyapplicantmodify`, {
                    type: 'personbuyer',
                    guid: this.applicantModified.guid,
                    name: this.applicantModified.name,
                    idType: this.applicantModified.idType,
                    idNum: this.applicantModified.idNum,
                });
                this.$toast('修改成功');
                this.applicant = Object.assign({}, this.applicantModified);
                this.editable = false;
            }
        }
    }
</script>

<style scoped>

</style>